import styled from "styled-components"
import { Form } from "@unform/web"

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  height: 100vh;
  width: 100vw;
  overflow: hidden;
`

export const Main = styled.main`
  flex: 1;
  display: grid;
  grid-template-columns: auto 1fr;

  height: 100%;
  min-height: 0;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;
  min-height: 0;

  padding: 15px;
  overflow: hidden;

  h1 {
    margin-bottom: 10px;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 22px;
    }
  }
`

export const GroupBox = styled.div`
  flex: 1;
  min-height: 0;

  display: flex;
  flex-direction: column;

  border-radius: 10px;
  border: 2px solid ${(props) => props.theme.colors.text};
`

export const StyledForm = styled(Form)`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  overflow: hidden;
  margin: 15px;
  gap: 10px;
`

export const FieldsContainer = styled.span`
  display: flex;
  flex-direction: row;

  gap: 5px;

  span {
    display: flex;
    flex-direction: row;

    gap: 5px;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }
`

export const ButtonsContainer = styled.span`
  display: flex;
  flex-direction: row;

  gap: 5px;
`

export const TabsContainer = styled.div`
  border-bottom: 2px solid ${(props) => props.theme.colors.secondaryBlue};

  button:first-child {
    border-right: 2px solid ${(props) => props.theme.colors.secondaryBlue};
  }
`

export const TabButton = styled.button<{ isActive: boolean }>`
  height: 40px;
  width: 50%;
  position: relative;

  background: none;
  border: none;

  font-size: 1.4rem;
  font-weight: 500;
  color: ${(props) =>
    props.isActive
      ? props.theme.colors.contrastOrange
      : props.theme.colors.text};

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 50%;
    transform: translateX(-50%);
    width: 50%;
    border-bottom: ${(props) =>
      props.isActive ? `2px solid ${props.theme.colors.contrastOrange}` : ""};
  }
`

export const SmallButton = styled.button`
  height: 56px;
  width: 56px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  border-radius: 8px;
  background-color: #1fa643;

  &.search {
    background-color: ${(props) => props.theme.colors.primaryBlue};
  }

  svg {
    width: 30px;
    height: 30px;

    stroke-width: 3px;

    color: white;
  }

  @media (max-width: 768px) {
    width: auto;
    height: 28px;

    svg {
      width: 15px;
      height: 15px;
    }
  }
`

export const TestsContainer = styled.div`
  flex: 1;
  min-height: 0;

  display: flex;
  flex-direction: column;

  overflow-y: auto;
`

export const TestCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  height: 80px;

  padding: 10px;

  color: black;

  border: 2px solid ${(props) => props.theme.colors.primaryBlue};
  border-left: 10px solid ${(props) => props.theme.colors.primaryBlue};

  margin-bottom: 12px;

  h4 {
    font-size: 18px;
    margin-bottom: 2px;
  }

  p {
    font-size: 17px;
  }

  svg {
    cursor: pointer;

    color: ${(props) => props.theme.colors.primaryBlue};

    height: 25px;
    width: 25px;

    &:hover {
      color: red;
    }
  }
`

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;

  flex: 1;
  min-height: 0;

  overflow-y: auto;

  gap: 12px;
`
export const SearchCard = styled.div`
  cursor: pointer;

  display: flex;
  align-items: center;

  padding: 10px;
  height: 50px;

  border: 2px solid ${(props) => props.theme.colors.primaryBlue};
  border-left: 10px solid ${(props) => props.theme.colors.primaryBlue};
`
